import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import * as _ from 'underscore';
declare var $: any;


@Component({
  selector: 'component-search-hotel',
  templateUrl: './search-hotel.component.html',
  styleUrls: ['./search-hotel.component.css']
})
export class SearchHotelComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedHotelEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'tradename';
  isTypedSearch = false;
  classSearch:any;

  constructor(private hotelService: HotelService) {}

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchHotels(event), 250);

  getSearchHotels(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.hotelService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
        }
      });
      // if(search_ === '%%'){
      //   console.log("entra aca");
      //   this.hotelService.all(val_params).subscribe({
      //     next: (data: any) => {
      //       setTimeout(() => {
      //         this.data = data.results;
      //         console.log(this.data);
      //       }, 250);
      //     }
      //   });
      // }else{
      //   console.log("testinf");
        
      // }      
    } else {
      this.data = [];
    }
  }

  selectSearchHotel(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);

    // this.closedSearchPanel();
    this.selectedHotelEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}
